import {
  useFormattedValue,
  useMathOperation,
  useValue,
} from '../../../hooks/useValue';
import { FieldPath, FormatConfig } from '../../../types';

export type Item = {
  variant?: 'price' | 'disclaimer' | 'row';
  value?: FieldPath;
  originalValue?: FieldPath;
  formatConfig?: FormatConfig;
  maximumFractionDigits?: number;
};

// here we get and format value and originalValue for DataItemBlock
// originaValue used in case if we need to compare smth or show discount
// so we may compare or cross originalValue and show value
export const useValueForDataItemBlock = (item: Item) => {
  // we try to calculate value and originalValue using math operations
  // they may require this or not, if they regular values, useMathOperation will do nothing
  const calculatedValue = useMathOperation(item.value);
  const calculatedOriginalValue = useMathOperation(item.originalValue);
  // then we get the same values in regular way
  const [value, status] = useValue(
    typeof item.value === 'string' ? item.value : ''
  );
  const [originalValueSimple] = useValue(
    typeof item.originalValue === 'string' ? item.originalValue : ''
  );

  // now if available we pick value or calculated value
  const valueToUse =
    typeof item.value === 'string' ? value : (calculatedValue as string);
  const originalValueToUse =
    typeof item.originalValue === 'string'
      ? originalValueSimple
      : (calculatedOriginalValue as string);
  //now we format both value and originalValue
  const formattedValue = useFormattedValue(
    valueToUse,
    item?.variant === 'price'
      ? { type: 'currency', maximumFractionDigits: item?.maximumFractionDigits }
      : item.formatConfig
  );
  const formattedOriginalValue = useFormattedValue(
    originalValueToUse,
    item?.variant === 'price'
      ? { type: 'currency', maximumFractionDigits: item?.maximumFractionDigits }
      : item.formatConfig
  );

  const withDiscount =
    valueToUse && originalValueSimple && originalValueSimple > valueToUse;
  const discount = withDiscount
    ? Math.floor((1 - Number(valueToUse) / Number(originalValueSimple)) * 100)
    : 0;

  return {
    status,
    discount,
    formattedValue,
    formattedOriginalValue,
  };
};
